/**
 * @generated SignedSource<<957eb02933ce55e7545d3274aaa44d8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientClass = "CUSTOMER" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type AddPlayersPrivateStepClientProfile$data = {
  readonly member: {
    readonly clientClass: ClientClass | null | undefined;
    readonly firstName?: string | null | undefined;
    readonly id?: string;
    readonly lastName?: string | null | undefined;
    readonly memberGroups?: ReadonlyArray<{
      readonly id: string;
    } | null | undefined> | null | undefined;
    readonly profileImage?: {
      readonly publicId: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "AddPlayersPrivateStepClientProfile";
};
export type AddPlayersPrivateStepClientProfile$key = {
  readonly " $data"?: AddPlayersPrivateStepClientProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddPlayersPrivateStepClientProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddPlayersPrivateStepClientProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "member",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clientClass",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "profileImage",
              "plural": false,
              "selections": [
                {
                  "alias": "publicId",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "renderingKey",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MemberGroup",
              "kind": "LinkedField",
              "name": "memberGroups",
              "plural": true,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "Member",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientProfile",
  "abstractKey": "__isClientProfile"
};
})();

(node as any).hash = "6c5f725baa892d834ac815f2dab2504b";

export default node;
